import ReportAccordion from '../common/ReportAccordion';
import { ActionState } from '@components/Activity/types/ActionState';
import { View, Text } from '@react-pdf/renderer';
import styles from '../common/styles';
import { toTitleCase } from '../common/Util';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

export const ActionReportAccordian = ({ actionState }: { actionState: ActionState }) => {
  const { t } = useTranslation();

  const actions = actionState.actionCardContentList;
  const longWidth = 350;
  const shortWidth = 100;

  return (
    <ReportAccordion header="action.form.details.page.container.action.required.add.action" noWrap>
      <View style={styles.table}>
        <View style={styles.tableRow}>
          <View style={[{ width: longWidth }, styles.bold]}>
            <Text>{t('action.form.details.page.container.action.required.container.label')}</Text>
          </View>
          <View style={[{ width: shortWidth }, styles.bold]}>
            <Text>
              {t('action.form.details.page.container.action.required.specify.date.for.deadline')}
            </Text>
          </View>
          <View style={[{ width: shortWidth }, styles.bold]}>
            <Text>{t('action.form.details.page.container.action.required.specify.resolver')}</Text>
          </View>
        </View>

        {actions.map(action => {
          return (
            <View style={styles.tableRow}>
              <View style={[{ width: longWidth }, styles.bold]}>
                <Text>{action.description}</Text>
              </View>
              <View style={[{ width: shortWidth }, styles.bold]}>
                <Text>{moment(action.deadlineDte).utc().format('DD-MM-YYYY')}</Text>
              </View>
              <View style={[{ width: shortWidth }, styles.bold]}>
                <Text>
                  {toTitleCase(
                    action.assignedUser?.firstName + ' ' + action.assignedUser?.lastName
                  )}
                </Text>
              </View>
            </View>
          );
        })}
      </View>
    </ReportAccordion>
  );
};
